import React, { useEffect, useState } from 'react';
import styles from './WelcomeScreenHeader.scss';
import { useData } from '../../hooks';
import { useMediaQuery } from 'ca-hooks';
import { CaLogo } from 'ca-logo';
import LocaleSelector, {
  LocaleCode,
} from 'ca-communications-page/KioskModeSettings/components/LocaleSelector/LocaleSelector';

export const WelcomeScreenHeader = () => {
  const {
    supported_locales,
    survey_logo,
    account_small_logo,
    welcome_screen_locale,
    account_name,
  } = useData();
  const desktop = useMediaQuery('(min-width:798px)');
  const searchParams = new URLSearchParams(window.location.search);

  const supportedLocales = supported_locales.map((item) => item.code);

  const [selectedLocale, setSelectedLocale] = useState<LocaleCode>(
    welcome_screen_locale.code as LocaleCode
  );

  useEffect(() => {
    if (selectedLocale !== welcome_screen_locale.code) {
      searchParams.set('locale', selectedLocale);
      window.location.search = searchParams.toString();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return (
    <div
      className={`${styles.WelcomeScreenHeaderContainer} ${
        (survey_logo || account_small_logo) && supported_locales.length > 1
          ? `max-[410px]:flex-col`
          : ''
      }`}
    >
      {desktop && <CaLogo styles={`${styles.WelcomeScreenHeaderCALogo}`} />}

      <div className={styles.WelcomeScreenHeaderLogoContainer}>
        <img
          src={survey_logo ? survey_logo : account_small_logo}
          alt={account_name}
        />
      </div>
      <div className={styles.WelcomeScreenHeaderLocalesMenu}>
        <div
          className={styles.WelcomeScreenHeaderLocalesSelector}
          data-automation-id="welcome-screen-language-selector"
        >
          {supported_locales.length > 1 && (
            <LocaleSelector
              supportedLocales={supportedLocales as LocaleCode[]}
              selectedLocale={selectedLocale}
              setSelectedLocale={setSelectedLocale}
              fullWidth={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};
